/* unplugin-vue-components disabled */import { render } from "./education.vue?vue&type=template&id=2b9c0592&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"

import "./education.vue?vue&type=style&index=0&id=2b9c0592&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9c0592"],['__file',"src/components/cards/persona/education/education.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b9c0592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b9c0592', __exports__)) {
    api.reload('2b9c0592', __exports__)
  }
  
  module.hot.accept("./education.vue?vue&type=template&id=2b9c0592&scoped=true", () => {
    api.rerender('2b9c0592', render)
  })

}


export default __exports__